export default __webpack_public_path__ + "static/media/menu_dash.f3a230ab.svg";